module.exports = function getResource(label, vars = []) {
    const resources = {
        straighteningLabel: 'Straightening',
        beingLabel: 'being'
    };

    return resources[label];
};
